/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type AgentsHomeEntryPointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const agentsHomeEntryPoint: EntryPoint<AgentsHomeEntryPointComponent, {}> = createEntryPoint(
	{
		root: JSResourceForInteraction<AgentsHomeEntryPointComponent>(
			/* webpackChunkName: "async-jira-project-settings-agents-home" */ './AgentsHomeApp.tsx',
		),
		getPreloadProps: () => ({}),
	},
);
